import { useCallback } from "react";
import { ResourceType } from "@/services/cloudchipr.api";
import { useLocalStorageHook } from "@/utils/hooks/useLocalStorage.hook";

export function useResourceCardCollapsedStateFromStorage(
  resourceType: ResourceType,
  initialState?: boolean,
) {
  const { getItem, setItem } = useLocalStorageHook();

  const key = `live-usage-${resourceType}-resourceCardConfig`;

  const config = getItem(key);
  const initialCollapsed =
    typeof config?.collapsed === "boolean" ? config?.collapsed : initialState;

  const setCollapsedState = useCallback(
    (collapsed: boolean) => {
      setItem(key, { ...config, collapsed });
    },
    [key, setItem, config],
  );

  return {
    collapsedState: initialCollapsed,
    setCollapsedState,
  };
}
